import { defineStore } from "pinia";
import ContentApi, { type BaseContent } from "@/data/api-layer/contentApi";

const useBaseContentStore = defineStore("baseContentStore", () => {
   const content = ref<BaseContent>(null);

   async function setContent() {
      const resp = await ContentApi.getBase();
      content.value = resp.content;
   }

   return { setContent, content };
});

export { useBaseContentStore };
